import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { productResourcesProps } from "@store/theme/props/productResources";
import React, { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

type Props = OwnProps & HasProductContext & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsImagesDownloadButtonStyles {
    imageLink?: LinkPresentationProps;
    list?: InjectableCss;
    listItem?: InjectableCss;
}

export const productDetailsImagesDownloadButtonStyles: ProductDetailsImagesDownloadButtonStyles = {
    list: productResourcesProps.list,
    listItem: productResourcesProps.listItem,
    imageLink: productResourcesProps.resourceLink,
};

const styles = productDetailsImagesDownloadButtonStyles;

const ProductDetailsImagesDownloadButton: FC<Props> = ({ productSettings, productContext }) => {
    const { product } = productContext;

    if (!product || !product.images) {
        return null;
    }

    const baseApiRouteV1 = "/api/v1";
    const downloadUrl = `${baseApiRouteV1}/products/${product.id}/storeCompressedImages`;

    const downloadHandler = () => {
        fetch(downloadUrl).then(response => {
            response.blob().then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                const disposition = response.headers.get("content-disposition");
                let filename = `${product.productNumber}-Images.zip`;
                if (disposition && disposition.indexOf("filename=") !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        });
    };

    return (
        <Typography as="ul" {...styles.list}>
            <Typography as="li" {...styles.listItem}>
                <Link onClick={downloadHandler} {...styles.imageLink}>
                    {translate("High Resolution Images")}
                </Link>
            </Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsImagesDownloadButton)),
    definition: {
        displayName: "Documents",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
